var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mobile-chat-wrapper" }, [
    _c("div", { staticStyle: { padding: "20px" } }, [
      _c(
        "p",
        {
          staticStyle: {
            color: "#fff",
            "font-size": "15px",
            "margin-bottom": "5px",
          },
        },
        [_vm._v("可选AI模型:")]
      ),
      _c(
        "div",
        { staticStyle: { display: "flex", "align-items": "center" } },
        _vm._l(_vm.aiModels, function (item) {
          return _c(
            "div",
            {
              key: item.type,
              class: { active: _vm.aiModel === item.type },
              staticStyle: {
                "margin-right": "20px",
                cursor: "pointer",
                padding: "5px",
                color: "#fff",
              },
              on: {
                click: function ($event) {
                  _vm.aiModel = item.type
                },
              },
            },
            [
              _c("img", {
                staticStyle: { height: "40px" },
                attrs: { src: item.icon, alt: "" },
              }),
              _c("p", [_vm._v(_vm._s(item.text))]),
            ]
          )
        }),
        0
      ),
    ]),
    JSON.stringify(_vm.programmeInfo) !== "{}" && _vm.programmeInfo.number
      ? _c(
          "div",
          {
            staticStyle: {
              "font-size": "16px",
              color: "#fff",
              padding: "0 20px",
            },
          },
          [
            _vm._v(
              " 出发日期：" +
                _vm._s(_vm.programmeInfo.startDate) +
                " 返程日期：" +
                _vm._s(_vm.programmeInfo.endDate) +
                " 预估人数：" +
                _vm._s(_vm.programmeInfo.number) +
                " "
            ),
          ]
        )
      : _vm._e(),
    _c("div", { staticClass: "chat-history" }, [
      _c(
        "div",
        { ref: "chatContent", staticClass: "chat-content" },
        _vm._l(_vm.chatList, function (item, index) {
          return _c("div", { key: item.id, staticClass: "chat-wrapper" }, [
            index != 0
              ? _c("div", [
                  item.role === "assistant"
                    ? _c("div", { staticClass: "chat-friend" }, [
                        _c("div", { staticClass: "info-time" }, [
                          _c("img", { attrs: { src: item.headImg, alt: "" } }),
                          _c("span", [_vm._v(_vm._s(item.name))]),
                          _c("span", [_vm._v(_vm._s(item.time))]),
                        ]),
                        item.role === "assistant"
                          ? _c(
                              "div",
                              {
                                ref: "chatText_" + index,
                                refInFor: true,
                                staticClass: "chat-text",
                                on: {
                                  click: function ($event) {
                                    return _vm.checkText(item.content, $event)
                                  },
                                },
                              },
                              [
                                !item.content && !item.reasoning && _vm.isSend
                                  ? [
                                      _c("span", {
                                        staticClass: "flash_cursor",
                                      }),
                                    ]
                                  : [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "12px",
                                          },
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "6px",
                                              },
                                            },
                                            [_vm._v("推理：")]
                                          ),
                                          _c("p", {
                                            staticStyle: { color: "#e5e5e5" },
                                            domProps: {
                                              innerHTML: _vm._s(item.reasoning),
                                            },
                                          }),
                                        ]
                                      ),
                                      item.content
                                        ? _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "6px",
                                              },
                                            },
                                            [_vm._v("正文：")]
                                          )
                                        : _vm._e(),
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(item.content),
                                        },
                                      }),
                                    ],
                              ],
                              2
                            )
                          : _vm._e(),
                      ])
                    : _c("div", { staticClass: "chat-me" }, [
                        _c("div", { staticClass: "info-time" }, [
                          _c("span", [_vm._v(_vm._s(item.name))]),
                          _c("span", [_vm._v(_vm._s(item.time))]),
                          _c("img", { attrs: { src: item.headImg, alt: "" } }),
                        ]),
                        item.role === "user"
                          ? _c("div", { staticClass: "chat-text" }, [
                              _vm._v(" " + _vm._s(item.content) + " "),
                            ])
                          : _vm._e(),
                      ]),
                ])
              : _vm._e(),
          ])
        }),
        0
      ),
    ]),
    _c(
      "div",
      { staticClass: "chat-input-wrapper" },
      [
        _c("el-input", {
          attrs: { disabled: _vm.isSend },
          model: {
            value: _vm.inputMsg,
            callback: function ($$v) {
              _vm.inputMsg = $$v
            },
            expression: "inputMsg",
          },
        }),
        _c(
          "el-select",
          {
            staticStyle: { "margin-left": "5px" },
            attrs: { placeholder: "请选择" },
            on: { change: _vm.clearChat },
            model: {
              value: _vm.chatType,
              callback: function ($$v) {
                _vm.chatType = $$v
              },
              expression: "chatType",
            },
          },
          _vm._l(_vm.options, function (item) {
            return _c("el-option", {
              key: item.value,
              attrs: { label: item.label, value: item.value },
            })
          }),
          1
        ),
        _vm.isSend
          ? _c("img", {
              staticClass: "send-icon",
              attrs: {
                alt: "",
                src: require("@/assets/img/emoji/zhongzhi.png"),
              },
              on: { click: _vm.abortFetch },
            })
          : _c("img", {
              staticClass: "send-icon",
              attrs: { alt: "", src: require("@/assets/img/emoji/rocket.png") },
              on: { click: _vm.sendText },
            }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }